import { connect } from 'react-redux';
import { getLoginRequestStatus } from '../../../reducers/selectors';

import {
  authWithSSO,
  logout,
  ssoAuthError,
  beginIdpAuthRedirect,
  ssoIdpAuthStart,
  ssoIdpAuthReceiveCode,
  ssoIdpAuthReceiveToken,
} from '../../../actions';

import SSOAuthLoginView from './SSOAuthLoginView';

const mapStateToProps = (state) => {
  const { session } = state;
  const loginRequestStatus = getLoginRequestStatus(state);

  return {
    session,
    isLoggingIn: loginRequestStatus,
  };
};

export default connect(mapStateToProps, {
  authWithSSO,
  ssoAuthError,
  logout,
  beginIdpAuthRedirect,
  ssoIdpAuthStart,
  ssoIdpAuthReceiveCode,
  ssoIdpAuthReceiveToken,
})(SSOAuthLoginView);
